<template>
  <div>
    <div class="row mb-2">
      <div class="col-md-12">
        <router-link
          :to="{ name: 'moderator.users.create' }"
          class="btn btn-primary btn-sm py-2 px-3 float-right"
          ><i class="lni lni-plus mr-2"></i> Add New</router-link
        >
        <h2>User Management</h2>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row justify-content-between">
          <div class="col-md-4">
            <form @submit.prevent="fetch">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search User"
                    aria-label="Search User"
                    aria-describedby="basic-addon2"
                    v-model="search.term"
                  />
                  <div class="input-group-append">
                    <button class="input-group-text" id="basic-addon2" type="submit"
                      ><i class="fa fa-search"></i
                    ></button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <select class="form-control" v-model="search.role" @change="fetch">
                <option value="0">All Users</option>
                <option value="1">Traders</option>
                <option value="2">Signal Subscribers</option>
                <option value="6">Learners</option>
                <option value="3">Guest Users</option>
                <option value="4">Affiliates</option>
                <option value="5">Moderators</option>
              </select>
            </div>
          </div>
        </div>
        <table class="table table-striped">
          <thead>
            <tr>
              <th colspan="2">Name</th>
              <th>Email</th>
              <th>Phone Number</th>
              <th>Role</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user, i) in users" :key="`user-${i}`">
              <td>
                <img :src="user.avatar" :alt="user.name" style="height: 40px">
              </td>
              <td>{{ user.name }} </td>
              <td>{{ user.email }}</td>
              <td>{{ user.phone_number }}</td>
              <td>{{ user.role }}</td>
              <td>
                <router-link v-if="user.role != 'admin'" :to="{ name: 'moderator.users.show', params: { id: user.id }}">Details</router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.fetch();
  },

  data() {
    return {
      search: { term: "", role: 0 },
      users: [],
    };
  },

  methods: {
    fetch() {
      this.$loader.start()
      this.$axios
        .get(
          `/api/v1/moderator/users?role=${this.search.role}&term=${this.search.term}`
        )
        .then((response) => {
          this.users = response.data.users;
          this.$loader.stop()
        });
    },
  },
};
</script>